import { Box } from "@mui/system";
import React, { useState } from "react";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";

export default function AddressAutoComplete(props) {
  const {disabled} = props
  const handlePlaceChange = (place) => {
    const payload = {
      target: {
        value: place,
        id: props.id,
      },
    };
    props.handleChange(payload);
  };

  return (
    <Box
      sx={{
        position: "relative",
        visibility : disabled ? 'hidden' : 'visible'

      }}
    >
      <span
        style={{
          fontSize: 12,
          lineHeight: 1.43,
          letterSpacing: "0.01071em",
          color: "rgba(255, 255, 255, 0.7)",
          position:'absolute',
          bottom:-22,
          left:0
        }}
      >{
        props.label
      }</span>
      <GooglePlacesAutocomplete
        apiKey="AIzaSyDgsVgL5W9_3gN88ZnJ2K9NzDfy5_cb7oA"
        selectProps={{
          value: props.value,
          onChange: handlePlaceChange,
        }}
        style={{
          maxWidth: "240px",
          minWidth: "240px",
          width: "240px",
          borderRadius: 0,
          height: "56px",
          visibility : disabled ? 'hidden' : 'visible'
          
        }}
      />
    </Box>
  );
}
